import React, { useState, useEffect, useMemo, useRef } from 'react'
import { ButtonGroup, Card, LoadingSpinner, Modal, Tooltip, Icon, Toggle } from 'pepsico-ds'
// import * as XLSX from 'xlsx';
import { exportRowsToExcel } from '../../utils/excelExport';
import { Col, Row, Button, Table } from 'antd'
import { formatNumberWithCommas, returnHyphenIfNull, handleDomToImgDownloadPdf } from '../../utils/utils'
import { localStoreKeys } from '../../constants/localStoreKeys'
// import ResilincModalFilters from './ResilincModalFilters'
import LegendList from '../Charts/Legend/LegendList'
import ResilincLegendList from '../Charts/Legend/ResilincLegendList'
import MapWithShapes from '../Charts/Map/MapWithCircles'
import RadarChartComponent from '../Charts/ResilincChart/RadarChartComponent'
import SingleBarChart from '../Charts/SpendAnalyticsChart/SingleBarChart';
import NoData from '../NoData/NoData';
import AntdTable from '../Table/AntdTable'
import colors from '../../styles/colors.scss';
import ResilincFormattedTable from '../Table/ResilincFormattedTable'
import { useSelector, useDispatch } from "react-redux";
import { setKeyValue } from "../../redux/reducer/localDataSlice";
import { urlConstants } from '../../constants/urlConstants';
import InfoIcon from '../Icons/InfoIcon';
import download_logo from '../../assets/download_logo.png'
import { trackModalView, getModalAttributes } from '../../utils/fullstory-utils';
import CustomButtons from '../Cards/CustomButtons';
import FilterWithSuppliers from './FilterWithSuppliers'
import DropdownWithIcons from './DropdownWithIcons';
import { useToast } from '../../components/Toast/ToastContext';
import Vector from '../../assets/Vector.png'
import domtoimage from "dom-to-image";
import domtoimagejpeg from 'dom-to-image-more'
import jsPDF from "jspdf";
import EDF_checked from "../../../src/assets/EDF_checked.svg";
import { staticNotes } from '../../constants/staticNotes';
import { spendResilincDropdownoptions, generatePdfFromNode, generateJpegFromNode, buildFileName, svgDropdownIcon } from '../../utils/utils';


const getRiskColor = (risk) => {
    if (risk==="-") return "#3A3A3A"
    if (risk >= 6.7) return colors.highRisk;
    else if (risk > 3.3) return colors.mediumRisk;
    return colors.lowRisk;
};



const columns = [
    {
        title: "Sub-tier Supplier Risk",
        dataIndex: "subTierSupplierRisk",
        key: "subTierSupplierRisk",
        // sorter: ((a, b) => (a['subTierSupplierRisk'] || '').toString().localeCompare((b['subTierSupplierRisk'] || '').toString())),
        render: (_, val) => {
            return <div style={{ color: getRiskColor(_), fontWeight: 700 }}>{_}</div>
        },
        // onCell: (record) => ({ rowSpan: Number(record.subIndex.split('-')[1]) > 1 ? Number(record.subIndex.split('-')[1]) : 0 })
    },
    {
        title: "Sub-tier Supplier Name",
        dataIndex: "subTierSupplierName",
        key: "subTierSupplierName",
    },
    {
        title: "Impacted Tier 1 Suppliers",
        dataIndex: "impactedTier1Suppliers",
        key: "impactedTier1Suppliers",
    },
];

const data = [
    {
        key: "1",
        columnA: "7.3",
        columnB: "6.7",
        riskType: "Supplier 1",
    },
    {
        key: "2",
        columnA: "",
        columnB: "",
        riskType: "Supplier 2",
    },
    {
        key: "3",
        columnA: "",
        columnB: "",
        riskType: "Supplier 3",
    },
    {
        key: "4",
        columnA: "6.2",
        columnB: "4.8",
        riskType: "Supplier 4",
    },
    {
        key: "5",
        columnA: "",
        columnB: "",
        riskType: "Supplier 5",
    },
    {
        key: "6",
        columnA: "",
        columnB: "",
        riskType: "Supplier 6",
    },
];

const columnsTable1 = [
    {
        title: 'Tier 1 Supplier Name',
        dataIndex: 'supplierName',
        key: 'supplierName',
        display: true,
        width: 150
    },
    {
        title: 'Resiliency Risk',
        dataIndex: 'resiliencyRisk',
        key: 'resiliencyRisk',
        display: true,
        width: 120,
        render: (_, val) => {
            return <div style={{ color: getRiskColor(_), fontWeight: 700 }}>{_}</div>
        }
    },
    {
        title: 'Sector',
        dataIndex: 'sector',
        key: 'sector',
        display: true,
        width: 100
    },
    {
        title: 'BU',
        dataIndex: 'bu',
        key: 'bu',
        display: true,
        width: 100
    },
    {
        title: 'Category L0',
        dataIndex: 'categoryL0',
        key: 'categoryL0',
        display: true,
        width: 100
    },
    {
        title: 'Category L1',
        dataIndex: 'categoryL1',
        key: 'categoryL1',
        display: true,
        width: 100
    },
    {
        title: 'Category L2',
        dataIndex: 'categoryL2',
        key: 'categoryL2',
        display: true,
        width: 150
    },
];
const dataTable1 = [
    {
        key: '1',
        supplierName: 'ABC',
        sector: 'AMESA',
        bu: 'India',
        categoryL0: 'GP Directs',
        categoryL1: 'Commodities',
        categoryL2: 'Wheat',
        resiliencyRisk: 6.4,
    },
    {
        key: '2',
        supplierName: 'XYZ',
        sector: 'APAC',
        bu: 'Australia',
        categoryL0: 'GP Indirects',
        categoryL1: 'Supply Chain',
        categoryL2: 'Transportation',
        resiliencyRisk: 4.8,
    },
    {
        key: '3',
        supplierName: 'Qwerty',
        sector: 'PBNA',
        bu: 'Pakistan',
        categoryL0: 'GP Directs',
        categoryL1: 'Packaging',
        categoryL2: 'Corrugated',
        resiliencyRisk: 7.9,
    },
    {
        key: '4',
        supplierName: 'Asd',
        sector: 'AMESA',
        bu: 'Saudi',
        categoryL0: 'GP Directs',
        categoryL1: 'Fruits & Vegetables',
        categoryL2: 'Corn',
        resiliencyRisk: 5.5,
    }
];

const sampleResilincData = [
    {
        "name": "PRICEWATERHOUSECOOPERS",
        "value": "21",
        "numericValue": 21,
        "unit": ""
    },
    {
        "name": "BAKER BOTTS",
        "value": "15",
        "numericValue": 15,
        "unit": ""
    },
    {
        "name": "BAKER BOTTS1",
        "value": "15",
        "numericValue": 15,
        "unit": ""
    },
    {
        "name": "SHINY SERVICES",
        "value": "12",
        "numericValue": 12,
        "unit": ""
    },
    {
        "name": "DHL EXPRESS",
        "value": "9",
        "numericValue": 9,
        "unit": ""
    },
    {
        "name": "DHL EXPRESS2",
        "value": "9",
        "numericValue": 9,
        "unit": ""
    },
    {
        "name": "QUESS CORP",
        "value": "6",
        "numericValue": 6,
        "unit": ""
    },
    {
        "name": "LAW OFFICE OF A ABBOUD AND ASSOCIATES",
        "value": "6",
        "numericValue": 6,
        "unit": ""
    },
    {
        "name": "AMERICAN LIFE INSURANCE",
        "value": "3",
        "numericValue": 3,
        "unit": ""
    }
]

const tooltipColumns = [
    {
        title: "Name",
        dataIndex: "name",
        key: "name",
    },
    {
        title: "Age",
        dataIndex: "age",
        key: "age",
    },
];

const tooltipData = [
    {
        key: "1",
        name: "John Doe",
        age: 32,
    },
    {
        key: "2",
        name: "Jane Smith",
        age: 28,
    },
];

const legendsChart2 = [
    { name: 'Risk >= 6.7', color: colors.highRisk },
    { name: '3.3 < Risk < 6.7', color: colors.mediumRisk },
    { name: 'Risk <= 3.3', color: colors.lowRisk },
];




function ResilincModal({ openModal, setOpenModal, userData, selectedYear, capability, userDataLandingPage, landingPageFilters }) {
    const MODAL_TITLE = 'Supplier Risk';

    const resilincModalRef = useRef()
    const Tier1SuppliersRiskFactorsRef = useRef()
    const Tier1SuppliersResiliencyRiskRef = useRef()
    const mapViewRef = useRef()
    const subTierFailureRef = useRef()
    const subTierSinglebarchartRef = useRef()
    const dropdownRef = useRef(null);
    const dropdownSingleBarRef = useRef(null);
    const [isJpegDownloaded, setIsJpegDownloaded] = useState(false);

    

    const [initialsubTierSinglebarchartRefSnapshot, setInitialsubTierSinglebarchartRefRefSnapshot] = useState(null);
    const [initialResilinModalSnapshot, setInitialResilinModalSnapshot] = useState(null);



    // Track modal view when opened
	
    useEffect(() => {
        if (openModal) {
            try {
                trackModalView(`${MODAL_TITLE} ${capability}`, 'view');
            } catch (error) {
                // Silent fail for tracking errors to not disrupt user experience
            }
        }
    }, [openModal, capability]);

	
    const handleClose = () => {
        try {
            trackModalView(`${MODAL_TITLE} ${capability}`, 'close');
        } catch (error) {
            // Silent fail for tracking errors
        }
        dispatch(setKeyValue({ key: localStoreKeys.isResilincModalOpened, value: true }));
        setDataLoadActionType("");
        // Close the modal
        setOpenModal(false);
    };

     // close dropdown when clicked outside
	
     useEffect(() => {
        const handleClickOutside = (e) => {
        if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
            setOpen(false);
        }

        if (dropdownSingleBarRef.current && !dropdownSingleBarRef.current.contains(e.target)) {
            setSingleBarOptionOpen(false);
        }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);


    const [loader, setLoader] = useState(true)
    const [resilincData, setResilincData] = useState({})
    const [buttonGroupItems, setButtonGroupItems] = useState([])
    const feedbackFormUrl = useSelector((state) => state?.localData?.data[localStoreKeys.feedbackFormUrl]);
    const isLoading = useSelector((state) => state?.loader?.isLoading);
    const dispatch = useDispatch();
    const [dataLoadActionType, setDataLoadActionType] = useState("");
    const [allowMapZoom, setAllowMapZoom] = useState(false);
    const [isDownloadSingleBarChart, setIsDownloadSingleBarChart] = useState(false);
    const [isResilincPdfDownloaded, setIsResilincPdfDownloaded] = useState(false);
    const [currentStateRef, setCurrentStateRef] = useState(false);
    const [currentKPIName, setCurrentKPIName] = useState('');

    const [showInprogressModal, setShowInprogressModal] = useState(false)

    const [open, setOpen] = useState(false);
    const [singleBarOptionOpen, setSingleBarOptionOpen] = useState(false);
  
    const toggleDropdown = () => setOpen(!open);
    const toggleSingleBarOptionDropdown = () => setSingleBarOptionOpen(!singleBarOptionOpen);

    const resiliencyRisk = Number(parseFloat(resilincData?.headerDetailsDto?.avgResiliencyRisk).toFixed(2)) || 0


    const totalSuppliers = resilincData?.headerDetailsDto?.totalSuppliers
    const tierOneSuppliers = resilincData?.headerDetailsDto?.tier1Suppliers
    const subTierSuppliers = resilincData?.headerDetailsDto?.tier2Suppliers
    const supplierSites = resilincData?.headerDetailsDto?.totalSites
    const tierOneSites = resilincData?.headerDetailsDto?.tier1Sites
    const pepsicoSites = resilincData?.headerDetailsDto?.pepsicoSites
    const subTierSites = resilincData?.headerDetailsDto?.tier2Sites
    const radarChartData = resilincData?.tier1SuppliersRiskFactor
    const isEDFIntegrated = resilincData?.edfintegrated;
    const locations = resilincData?.mapDetails
    const temptier1SuppliersResiliencyRisk = resilincData?.tier1SuppliersResiliencyRisk
    const tier1SuppliersResiliencyRisk = temptier1SuppliersResiliencyRisk?.map(item => ({
        ...item,
        resiliencyRisk: item.resiliencyRisk === null ? '-' : item.resiliencyRisk
      }));
    const tier2MappedToTier1 = resilincData?.tier2MappedToTier1
    const subTierFailurePointDetails = resilincData?.subTierFailurePointDetails

    const transformedSupplierMappingData = tier2MappedToTier1?.map(item => ({
        name: item.supplierName,
        value: item.countOfTier2Suppliers.toString(),
        numericValue: item.countOfTier2Suppliers,
        unit: ""
    }));
    
    const getResilincData = (value) => {
        setResilincData(value.data)
        setLoader(value.loader)
        setDataLoadActionType(value?.data?.type)
        // console.log(value.data)

        const appList = value.data?.apps
        if (appList && appList.length > 0) {
            const tempbuttonGroupItems = [
                
               { icon: "ondemand_video", label: "", onClick: () => window.open(urlConstants.resilincVideo, "_blank") },
                ...appList
                .filter(item => item.isActive)
                .map(item => ({
                    label: item.app,
                    onClick: () => window.open(item.url, "_blank"),
                }))
            ];

            setButtonGroupItems(tempbuttonGroupItems)
        }
        
    }

    const overallRiskColor = getRiskColor(resiliencyRisk)

    // const subTierFailurePointFunction = () => {
    //     const data = []
    //     let keyCounter = 1;
    //     subTierFailurePointDetails?.forEach((item, index) => {
    //         item.impactedTier1Suppliers.forEach((supplier, subIndex) => {
    //             data.push({
    //                 key: (keyCounter++),
    //                 subTierSupplierRisk: item.subTierSupplierRisk.toString(),
    //                 subTierSupplierName: item.subTierSupplierName,
    //                 impactedTier1Suppliers: supplier,
    //                 subIndex: `${index + 1}-${subIndex + 1}`,
    //             });
    //         });
    //     });

    //     return data
    // }

    // const mergedColumns = columns.map((col) => {
    //     const rowSpanMap = {};
    //     const abc = subTierFailurePointFunction()
    //     abc?.forEach((item) => {
    //         if (!rowSpanMap[item.subTierSupplierName]) {
    //             const count = abc?.filter(i => i.subTierSupplierName === item.subTierSupplierName).length;
    //             rowSpanMap[item.subTierSupplierName] = count;
    //         }
    //     });

    //     if (col.dataIndex === "subTierSupplierRisk" || col.dataIndex === "subTierSupplierName") {
    //         const newCol = {
    //             ...col,
    //             display: true,
    //             sorter: ((a, b) => (a[col.dataIndex] || '').toString().localeCompare((b[col.dataIndex] || '').toString())),
    //             onCell: (record, rowIndex) => {
    //                 // Calculate rowSpan before rendering
    //                 const rowSpan =
    //                     rowIndex === 0 ||
    //                         record.subTierSupplierName !== subTierFailurePointFunction()[rowIndex - 1]?.subTierSupplierName
    //                         ? subTierFailurePointFunction().filter(
    //                             (item) => item.subTierSupplierName === record.subTierSupplierName
    //                         ).length
    //                         : 0;

    //                 return { rowSpan };
    //             },
    //         };
    //         return newCol
    //     }
    //     return { ...col, display: true };
    // });

    // console.log("subTierFailurePointDetails",subTierFailurePointDetails)

      const { showToast } = useToast();

      /* istanbul ignore next */
          const downloadExcel = async () => {
              // Define the columns to keep and the desired order
              const columnsToInclude = [
                "TIER 1 SUPPLIER NAME",
                "RESILIENCY RISK",
                "SECTOR",
                "BU",
                "CATEGORY L0",
                "CATEGORY L1",
                "CATEGORY L2",
              ];
              
              const columnMapping = {
                "supplierName": "TIER 1 SUPPLIER NAME",
                "resiliencyRisk": "RESILIENCY RISK",
                "sector": "SECTOR",
                "bu": "BU",
                "categoryL0": "CATEGORY L0",
                "categoryL1": "CATEGORY L1",
                "categoryL2": "CATEGORY L2"
              };
            
              // Transform the data
              const transformedData = tier1SuppliersResiliencyRisk?.map(item => {
                const newItemRFTable = {};
                columnsToInclude.forEach(col => {
                  const originalKey = Object.keys(columnMapping).find(key => columnMapping[key] === col);
                  newItemRFTable[col] = item[originalKey];
                });
                return newItemRFTable;
              });
            
              await exportRowsToExcel({
                rows: transformedData,
                headers: columnsToInclude,
                fileName: 'TIER 1 SUPPLIER RESILIENCY RISK.xlsx',
              });
            };


    
      const checkPDFDownloaded = (isPdfDownloaded, isModal, fileURL, isExcel, isTable, isJpeg) => {
        if(isPdfDownloaded){
            if(isModal){
                showToast('success', !isJpeg ? "PDF of full page successfully downloaded." : 'JPEG of full page successfully downloaded.', {
                    icon: <img src={Vector} alt='image' style={{ width: '20px', height: '20px' }} />
                });
            } else if(isTable){
                showToast('success', !isJpeg ? "PDF of a table successfully downloaded." : 'JPEG of a table successfully downloaded.', {
                    icon: <img src={Vector} alt='image' style={{ width: '20px', height: '20px' }} />
                });
            }
            else{
                showToast('success', !isJpeg ? "PDF of a chart successfully downloaded.": 'JPEG of a chart successfully downloaded.', {
                    icon: <img src={Vector} alt='image' style={{ width: '20px', height: '20px' }} />
                });
            }
           

        }
        else if(isExcel){
            downloadExcel()
        }
        else{
            showToast('Error', "Failed to download. Please try again.", {
                icon: <img src={Vector} alt='image' style={{ width: '20px', height: '20px' }} />
            });
        }   
      }

	
        useEffect(()=>{
            setIsDownloadSingleBarChart(false)
        }, [isResilincPdfDownloaded])

	
        useEffect(()=>{
            setShowInprogressModal(true)
            
            const downloadResilincJpeg = async(opts=[]) => {
                try{

                    const fileName = buildFileName(currentKPIName, "jpeg");
        
                    await generateJpegFromNode({
                    node: currentStateRef.current,
                    fileName,
                    ...opts,
                    });
                    setIsResilincPdfDownloaded(true)
                    // setIsJpegDownloaded(true)
                    setShowInprogressModal(false)
                    checkPDFDownloaded(true, currentKPIName == 'Resilinc_Modal' ? true : false, "", false, false, true)
                }
                catch(error){
                    setIsResilincPdfDownloaded(true)
                    // setIsJpegDownloaded(true)
                    setShowInprogressModal(false)
                    console.error('Error exporting chart as JPEG', error);
                    checkPDFDownloaded(false, currentKPIName == 'Resilinc_Modal' ? true : false, "", false, false, false)
                };
    
                return
            }

            const downloadResilincPdf = async(opts=[]) => {

                try { 
                    await generatePdfFromNode({
                        node: currentStateRef.current,
                        currentKPIName,
                        opts,
                      });

                setIsResilincPdfDownloaded(true)
                setShowInprogressModal(false)
                checkPDFDownloaded(true, currentKPIName == 'Resilinc_Modal' ? true : false, "", false, false)
            } catch (err) {
                setIsResilincPdfDownloaded(true)
                setShowInprogressModal(false)
                console.error("Failed to generate PDF:", err);
                checkPDFDownloaded(false, currentKPIName == 'Resilinc_Modal' ? true : false, "", false, false, false)
            }
            }
            
            if(isDownloadSingleBarChart){
                setTimeout(() => {
                    if(isJpegDownloaded){
                        downloadResilincJpeg()
                    }else{
                        downloadResilincPdf()
                    }
                    
                }, [2000]);
                
            }
            else{
                setIsResilincPdfDownloaded(false)
                setIsJpegDownloaded(false)
                setShowInprogressModal(false)
                return
            }
             
        }, [isDownloadSingleBarChart])

        // Take snapshot of initially rendered DOM once
        // useEffect(() => {
        //     const subTierSinglebarchartRefTimer = setTimeout(() => {
        //         domtoimage
        //           .toPng(subTierSinglebarchartRef.current, { quality: 1, cacheBust: true })
        //           .then((dataUrl) => {
        //             setInitialsubTierSinglebarchartRefRefSnapshot(dataUrl);
        //           })
        //           .catch((err) => console.error("Snapshot error:", err));
        //       }, 1000); 

        //       const resilincModalRefTimer = setTimeout(() => {
        //         domtoimage
        //           .toPng(resilincModalRef.current, { quality: 1, cacheBust: true })
        //           .then((dataUrl) => {
        //             setInitialResilinModalSnapshot(dataUrl);
        //           })
        //           .catch((err) => console.error("Snapshot error:", err));
        //       }, 1000); 
              
        //       return () => {
        //         clearTimeout(resilincModalRefTimer);
        //         clearTimeout(subTierSinglebarchartRefTimer);
        //       };
        // }, [transformedSupplierMappingData]); // run only once after mount



        // useEffect(() => {
        //     const subTierSinglebarchartRefTimer = domtoimage
        //           .toPng(subTierSinglebarchartRef.current, { quality: 1, cacheBust: true })
        //           .then((dataUrl) => {
        //             setInitialsubTierSinglebarchartRefRefSnapshot(dataUrl);
        //           })
        //           .catch((err) => console.error("Snapshot error:", err));

        //       const resilincModalRefTimer =  domtoimage
        //           .toPng(resilincModalRef.current, { quality: 1, cacheBust: true })
        //           .then((dataUrl) => {
        //             setInitialResilinModalSnapshot(dataUrl);
        //           })
        //           .catch((err) => console.error("Snapshot error:", err));
              
        //       return () => {
        //         clearTimeout(resilincModalRefTimer);
        //         clearTimeout(subTierSinglebarchartRefTimer);
        //       };
        // }, [transformedSupplierMappingData]); // run only once after moun

    //     const resilincHandleDomToImgDownloadPdf = async (ref, kpiName) => {
    //         setIsDownloadSingleBarChart(true)
     
    //         console.log("transformedSupplierMappingData", transformedSupplierMappingData)
    //         // const node = ref.current
    //         //  try {
    //         //  const dataUrl = await domtoimage.toPng(node, {
    //         //      quality: 1,
    //         //      cacheBust: true,
    //         //  });
     
    //         //  const pdf = new jsPDF({
    //         //      orientation: "portrait",
    //         //      unit: "mm",
    //         //      format: "a4", // A2 paper size
    //         //  });
     
    //         //  const img = new Image();
    //         //  img.src = dataUrl;
     
    //         //  img.onload = () => {
    //         //              const imgProps = pdf.getImageProperties(dataUrl);
    //         //              const pageWidth = pdf.internal.pageSize.getWidth();
    //         //              const pageHeight = pdf.internal.pageSize.getHeight();
     
    //         //              let pdfWidth = pageWidth;
    //         //              let pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
     
    //         //              // Resize if image is too tall
    //         //              if (pdfHeight > pageHeight) {
    //         //              pdfHeight = pageHeight;
    //         //              pdfWidth = (imgProps.width * pdfHeight) / imgProps.height;
    //         //              }
     
    //         //              const x = (pageWidth - pdfWidth) / 2;
    //         //              const y = (pageHeight - pdfHeight) / 2;
     
    //         //              pdf.addImage(dataUrl, 'PNG', x, y, pdfWidth, pdfHeight);
                         
     
    //         //              // Build dynamic filename in "refVal_YYYYMMDD" format
    //         //             const today = new Date();
    //         //             const yyyy = today.getFullYear();
    //         //             const mm = String(today.getMonth() + 1).padStart(2, "0");
    //         //             const dd = String(today.getDate()).padStart(2, "0");
    //         //             const formattedDate = `${yyyy}${mm}${dd}`;
     
    //         //             const fileName = `${kpiName}_${formattedDate}.pdf`;
    //         //             pdf.save(fileName);
     
    //         //          //    showToast('success', "Pdf downloaded", {
    //         //          //     icon: <img src={Vector} alt='image' style={{ width: '20px', height: '20px' }} />
    //         //          // });
                         
    //         //             //  setIsDownloadSingleBarChart(false)
    //         //          };
    //         //          } catch (error) {
    //         //          console.error("Failed to generate PDF:", error);
    //         //         //  setIsDownloadSingleBarChart(false)
    //         //  }
    //   };

    // const options = [
    //     {
    //       label: "Download as PDF",
    //       icon: (
    //         <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
    //           xmlns="http://www.w3.org/2000/svg">
    //           <g clipPath="url(#clip0_400_531382)">
    //             <path d="M3.225 0C2.345 0 1.633 0.72 1.633 1.6L1.625 14.4C1.625 15.28 2.337 16 3.217 16H12.825C13.705 16 14.425 15.28 14.425 14.4V4.8L9.625 0H3.225ZM8.825 5.6V1.2L13.225 5.6H8.825Z" fill="#8D466D"/>
    //           </g>
    //           <defs>
    //             <clipPath id="clip0_400_531382">
    //               <rect width="16" height="16" fill="white"/>
    //             </clipPath>
    //           </defs>
    //         </svg>
    //       ),
    //     },
    //     {
    //         label: "Download as JPEG",
    //         icon: (
    //           <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    //             <path d="M2.225 0C1.345 0 0.633 0.72 0.633 1.6L0.625 14.4C0.625 15.28 1.337 16 2.217 16H11.825C12.705 16 13.425 15.28 13.425 14.4V4.8L8.625 0H2.225ZM7.825 5.6V1.2L12.225 5.6H7.825Z" fill="#8458CC"/>
    //           </svg>
    
    //         ),
    //       },
    //     // ...(isTable
    //     //   ? [
    //     //       {
    //     //         label: "Download as XLS",
    //     //         icon: (
    //     //           <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    //     //           <path d="M2.225 0C1.345 0 0.633 0.72 0.633 1.6L0.625 14.4C0.625 15.28 1.337 16 2.217 16H11.825C12.705 16 13.425 15.28 13.425 14.4V4.8L8.625 0H2.225ZM7.825 5.6V1.2L12.225 5.6H7.825Z" fill="#008553"/>
    //     //           </svg>
    
    //     //         ),
    //     //       },
    //     //     ]
    //     //   : []),
    //   ];

	
    const svgSingleBarDropdownIcon = (isModal, refName, kpiName, isTable) => {
        return(
        <>
            <div ref={dropdownSingleBarRef}
             style={{ position: "relative", display: "inline-block", background: 'white', 
                      height: '30px', borderRadius: '5px', border: '1px solid #d3caca'}}>
            {/* Trigger Button */}
            <div style={{display: 'flex'}}>
            <Tooltip text={isModal ? 'Download Full Page' : isTable ? 'Download this table' : 'Download this chart'} direction={isModal ? "left": "top-middle"} style={{display: 'flex !important', zIndex: '999999'}}>
                <button
                onClick={toggleSingleBarOptionDropdown}
                style={{
                    background: "white",
                    border: "none",
                    cursor: "pointer",
                    display: 'flex',
                    position: 'relative',
                    top: '0.35rem'
                }}
                >
                <Icon
                    alt="alt value"
                    icon={"download"}
                    size="small"
                    style={{ color: '#005cbc' }}
                />
                <Icon
                    alt="alt value"
                    icon={"arrow_drop_down"}
                    size="small"
                    style={{ color: '#005cbc' }}
                />
                {/* <img src={DownloadFileFormat} alt="download" /> */}
                </button>
            </Tooltip>
            </div>
    
            {/* Dropdown Menu */}
            {singleBarOptionOpen && (
                <ul
                style={{
                    position: "absolute",
                    // top: "120%",
                    right: 0,
                    background: "white",
                    listStyle: "none",
                    padding: "4px 0",
                    margin: 0,
                    border: "1px solid #ddd",
                    borderRadius: "6px",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                    minWidth: "150px",
                    fontSize: "12px",
                    zIndex: '99999'
                }}
                >
                {spendResilincDropdownoptions.map((opt, idx) => (
                    <li
                    key={idx}
                    role="button" 
                    tabIndex={0}
                    style={{
                        padding: "0 5px",
                        display: "flex",
                        alignItems: "center",
                        height: '1.5rem',
                        cursor: "pointer",
                    }}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                          e.preventDefault();
                          e.currentTarget.click();
                        }
                    }}
                    onClick={() => {
                        setIsDownloadSingleBarChart(true);
                        setIsJpegDownloaded(opt.label == "Download as JPEG" ? true : false)
                        setCurrentStateRef(refName);
                        setCurrentKPIName(kpiName)
                        setSingleBarOptionOpen(false);
                    }}
                    onMouseEnter={(e) =>
                        (e.currentTarget.style.background = "#f5f5f5")
                    }
                    onMouseLeave={(e) =>
                        (e.currentTarget.style.background = "transparent")
                    }
                    >
                    {opt.icon}
                    <span style={{ marginLeft: "6px", fontWeight: '500' }}>{opt.label}</span>
                    </li>
                ))}
                </ul>
            )}
            </div>
        </>
        )
    }
    

    
    return (
        <Modal
            onCloseModal={handleClose}
            primaryButtonProps={{
                onClick: handleClose,
                size: "medium",
                text: "Close",
                variant: "primary",
            }}
            showPrimaryButton={true}
            showLink={false}
            showSecondaryButton={false}
            showTertiaryButton={false}
            showAuxiliaryButton={false}
            showSlot={true}
            showModal={openModal}
            closeOnOutsideClick={false}
            hideCloseButton={false}
            type="XL"
            {...getModalAttributes(`${MODAL_TITLE} ${capability}`)}
        >
            <div ref={resilincModalRef}>
                <div className="modal-title" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <span>
                        {userData.FirstName}, Average Resiliency Risk for Tier 1 suppliers is <b style={{ color: overallRiskColor }}>{resiliencyRisk}</b>
                        {
                            isEDFIntegrated &&
                            <Tooltip direction="bottom" text={staticNotes.EDF_NOTE}>
                                <img src={EDF_checked} alt='image' style={{ width: '18px', height: '22px', marginLeft: "8px", overflow:"visible", marginBottom: "7px" }} />
                            </Tooltip>
                        }
                    </span>
                    {
                        isLoading ? (
                            <></>
                        ) :                    
                        <>
                            {/* <ButtonGroup
                                style={{ marginRight: '2rem' }}
                                className="buy-con-button-group"
                                items={buttonGroupItems}
                                size="small"
                            /> */}
                            {/* <CustomButtons isModal={true} appList={buttonGroupItems} /> */}
                            
                        
                            <span style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                                <CustomButtons isModal={true} appList={
                                    [
                                        { icon: 'ondemand_video', label: '', "url": "https://pepsico.sharepoint.com/:v:/r/teams/DigitalProcurement-BuyersConsolePOC/Shared%20Documents/General%20-/Workstream%20Documentation/Background,%20Discovery%20%26%20Requirements/App%20Videos/Resilinc%20video.mp4?csf=1&web=1&e=ilq1sv" },
                                        ...(resilincData?.apps ?? [])
                                    ]
                                }   
                                />
                                {/* <button onClick={() => handleDomToImgDownloadPdf(resilincModalRef, "Resilinc_Modal")}>PDF</button> */}
                                {/* <span style={{float: 'right', position: 'relative', right: '2rem', bottom: '0.6rem'}}> */}
                                    {/* <DropdownWithIcons modalRef={resilincModalRef} kpiName={"Resilinc_Modal"} isModal={true} checkPDFDownloaded={checkPDFDownloaded} isSingleBarChart={true} initialSnapshot={initialResilinModalSnapshot}/> */}
                                    {/* <DropdownWithIcons modalRef={resilincModalRef} kpiName={"Resilinc_Modal"} isModal={true} checkPDFDownloaded={checkPDFDownloaded} /> */}
                                {/* </span> */}

                                {/* <button onClick={() => {
                                    setIsDownloadSingleBarChart(true);
                                    setCurrentStateRef(resilincModalRef);
                                    setCurrentKPIName('Resilinc_Modal')
                                    }}>
                                                                PDF
                                </button> */}
                                <span style={{float: 'right', position: 'relative', bottom: '0.6rem', right: '2rem'}}>
                                    {svgDropdownIcon(true, resilincModalRef, 'Resilinc_Modal', false, dropdownRef, toggleDropdown, open, spendResilincDropdownoptions, setIsDownloadSingleBarChart, setIsJpegDownloaded, setCurrentStateRef, setCurrentKPIName, setOpen  )}
                                </span>
                            </span>
                        
                        
                        </>
                    }
                </div>
                {/* <div className="modal-update-frequesncy" style={{ marginBottom: "5px", display: "flex" }}>{"Current risk scores reflect Resilinc’s standard methodology. The Digital Proc team is collaborating with Proc Excellence to develop a customized risk framework aligned to PepsiCo’s risk identification approach, targeted for availability in Q3 2026."}</div> */}
                <div className="modal-update-frequesncy">Data As On: {returnHyphenIfNull(resilincData?.lastUpdate)} | Refresh Frequency: {returnHyphenIfNull(resilincData?.refreshFrequency)}</div>
                {/* <ResilincModalFilters selectedYear={selectedYear} capability={capability} userData={userDataLandingPage} onParentCallback={getResilincData} landingPageFilters={landingPageFilters} setLoader={setLoader} /> */}
                <FilterWithSuppliers selectedYear={selectedYear} capability={capability} userData={userDataLandingPage} onParentCallback={getResilincData} landingPageFilters={landingPageFilters} setLoader={setLoader} />
                <br />
                {
                    (loader || isLoading) ?
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: 300 }}>
                            <LoadingSpinner size={{ height: '80px', width: '80px' }} />
                        </div>
                        :
                        <>
                            <Row gutter={[5, 5]} justify={"start"} style={{ width: "100%", position: 'relative' }}>
                                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                <Card style={{ height: '100%',display:'flex' }}>
                                <div className='header-kpi-wrapper'>
                                <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                                {
                                    resiliencyRisk !== undefined && resiliencyRisk !== null && resiliencyRisk !== 0 ?
                                    <>
                                        <div className="spend-modal-alphanumeric-value">
                                            <div className='spend-modal-numeric-value' style={{ color: overallRiskColor }}>{formatNumberWithCommas(resiliencyRisk) || 0}</div>
                                        </div>
                                        <div className='spend-modal-total-spend-text' style={{ display: "flex" }}>Avg Resiliency Risk<br/> for Tier 1 Suppliers</div>
                                    </>: ''
                                }
                                </Col>
                                {
                                    totalSuppliers !== undefined && totalSuppliers !== null ?
                                        <>
                                            <div className="compass-modal-divider-verticle" />
                                            <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                                                <div style={{ display: 'flex',justifyContent:"space-between" }}>
                                                    <div>
                                                        <div className="spend-modal-alphanumeric-value-small">
                                                            <div className='spend-modal-numeric-value-small'>{totalSuppliers ? formatNumberWithCommas(totalSuppliers) : 0}</div>
                                                        </div>
                                                        <div className='spend-modal-manage-spend'># Suppliers<br/> Monitored</div>
                                                    </div>

                                                    <div>
                                                        <div className="kpi-card-last-year-value">
                                                                <span className="last-year">#Tier-1</span>
                                                        </div>
                                                        <br/>
                                                        <div className="kpi-card-percentage-value" style={{maxHeight:"30px", marginTop:"-15px", fontWeight:"normal"}}>{tierOneSuppliers ? formatNumberWithCommas(tierOneSuppliers) : 0}
                                                        </div>
                                                    </div>

                                                    <div style={{position:"relative", marginRight:"112px"}}>
                                                        <div className="kpi-card-last-year-value" >
                                                                <span className="last-year"># Sub-tier</span>
                                                        </div>
                                                        <br/>
                                                        <div className="kpi-card-percentage-value" style={{maxHeight:"30px", marginTop:"-15px", fontWeight:"normal"}}>{subTierSuppliers ? formatNumberWithCommas(subTierSuppliers) : 0}
                                                        </div>
                                                    </div>

                                                    
                                                </div>
                                                {/* <div style={{ display: 'flex', marginTop: 10 }}>
                                                    <div style={{ width: '50%' }}>
                                                        <div className="spend-modal-alphanumeric-value-small">
                                                            <div className='spend-modal-numeric-value-small' style={{ fontSize: 18 }}>{tierOneSuppliers ? formatNumberWithCommas(tierOneSuppliers) : 0}</div>
                                                        </div>
                                                        <div className='spend-modal-manage-spend'># Tier 1 Suppliers</div>
                                                    </div>
                                                    <div>
                                                        <div className="spend-modal-alphanumeric-value-small">
                                                            <div className='spend-modal-numeric-value-small' style={{ fontSize: 18 }}>{subTierSuppliers ? formatNumberWithCommas(subTierSuppliers) : 0}</div>
                                                        </div>
                                                        <div className='spend-modal-manage-spend'># Sub-tier Suppliers</div>
                                                    </div>
                                                </div> */}
                                            </Col>
                                        </> : ''
                                }
                                {
                                    supplierSites !== undefined && supplierSites !== null ?
                                        <>
                                            <div className="compass-modal-divider-verticle" />
                                            <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                                                <div style={{ display: 'flex',justifyContent:"space-between" }}>
                                                    <div>
                                                        <div className="spend-modal-alphanumeric-value-small">
                                                            <div className='spend-modal-numeric-value-small'>{supplierSites ? formatNumberWithCommas(supplierSites) : 0}</div>
                                                        </div>
                                                        <div className='spend-modal-manage-spend'># Sites<br/>Monitored</div>
                                                    </div>
                                                
                                                    <div>
                                                        <div className="kpi-card-last-year-value">
                                                                <span className="last-year">#Tier-1</span>
                                                        </div>
                                                        <br/>
                                                        <div className="kpi-card-percentage-value" style={{maxHeight:"30px", marginTop:"-15px", fontWeight:"normal"}}>{tierOneSites ? formatNumberWithCommas(tierOneSites) : 0}
                                                        </div>
                                                    </div>

                                                    <div style={{position:"relative"}}>
                                                        <div className="kpi-card-last-year-value">
                                                                <span className="last-year"># Sub-tier</span>
                                                        </div>
                                                        <br/>
                                                        <div className="kpi-card-percentage-value" style={{maxHeight:"30px", marginTop:"-15px", fontWeight:"normal"}}>{subTierSites ? formatNumberWithCommas(subTierSites) : 0}
                                                        </div>
                                                    </div>

                                                    
                                                    <div style={{position:"relative"}}>
                                                        <div className="kpi-card-last-year-value">
                                                                <span className="last-year"># PepsiCo sites</span>
                                                        </div>
                                                        <br/>
                                                        <div className="kpi-card-percentage-value" style={{maxHeight:"30px", marginTop:"-15px", fontWeight:"normal"}}>{pepsicoSites ? formatNumberWithCommas(pepsicoSites) : 0}
                                                        </div>
                                                    </div>
                                                </div>    
                                                {/* <div style={{ display: 'flex', marginTop: 10 }}>
                                                    <div style={{ width: '50%' }}>
                                                        <div className="spend-modal-alphanumeric-value-small">
                                                            <div className='spend-modal-numeric-value-small' style={{ fontSize: 18 }}>{tierOneSites ? formatNumberWithCommas(tierOneSites) : 0}</div>
                                                        </div>
                                                        <div className='spend-modal-manage-spend'># Tier 1 Sites</div>
                                                    </div>
                                                    <div>
                                                        <div className="spend-modal-alphanumeric-value-small">
                                                            <div className='spend-modal-numeric-value-small' style={{ fontSize: 18 }}>{subTierSites ? formatNumberWithCommas(subTierSites) : 0}</div>
                                                        </div>
                                                        <div className='spend-modal-manage-spend'># Sub-tier Sites</div>
                                                    </div>
                                                </div> */}
                                            </Col>
                                        </> : ''
                                }
                                </div>
                            </Card>
                            </Col> 
                            </Row>
                            <br />
                            <Row>
                                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                    <div className="resiliency-legend-container">Risk Scores Legend</div>
                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <ResilincLegendList legends={legendsChart2} />
                                    </div>
                                </Col>
                            </Row>
                            <br />

                            <Row gutter={[10, 10]} justify={"start"} style={{ width: "100%" }}>
                                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                    <div ref={Tier1SuppliersRiskFactorsRef} style={{height:'100%'}}>
                                        <Card style={{ height: '100%' }} className="archlet-chart-card">
                                        {
                                            radarChartData && radarChartData?.length > 0 ?
                                                <>
                                            <Row align={'middle'}>
                                                <Col xs={16} sm={16} md={16} lg={16} xl={16}>
                                                    <div className="archlet-chart-title" >
                                                        <span>Tier 1 Suppliers Risk Factors</span>
                                                        
                                                    </div>
                                                </Col>
                                                <Col xs={8} sm={8} md={8} lg={8} xl={8}>
                                                    <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
                                                        {/* <span style={{position: 'relative', right: '1rem'}}> */}
                                                            <div style={{ display: "flex", alignItems: "center" }}>
                                                                {
                                                                    resiliencyRisk !== undefined && resiliencyRisk !== null && resiliencyRisk !== 0 ?
                                                                    <div style={{ margin: 0, marginRight: "10px", fontSize: "40px", fontWeight: 700, color: overallRiskColor, position:"relative", marginLeft:"90px", right: '0.5rem' }}>
                                                                        {resiliencyRisk}
                                                                    </div>:""
                                                                }
                                                                {/* <span>Overall Resiliency Risk</span> */}
                                                            </div>
                                                            <Tooltip text={
                                                                <>
                                                                    <div style={{ fontWeight: 700, fontSize: 14 }} >Overall Resiliency Risk</div>
                                                                    <br/>
                                                                    <div style={{ fontWeight: "bold", fontSize: "12px" }}>Risk Type & Weight</div>
                                                                    <div>Natural Disaster - 20%</div>
                                                                    <div>Macroeconomic - 20%</div>
                                                                    <div>Geopolitical - 20%</div>
                                                                    <div>Resilinc Financial Risk - 10%</div>
                                                                    <div>Resilinc Ops Risk - 6%</div>
                                                                    <div>Resilinc Compliance Risk - 6%</div>
                                                                    <div>Resilinc ESG Risk - 6%</div>
                                                                    <div>Resilinc Geopolitical Risk - 6%</div>
                                                                    <div>Resilinc Infosec Risk - 6%</div>
                                                                </>
                                                            }
                                                            // style={{position: 'relative', right: '0.5rem'}}
                                                            className='resilinc-spider-graph'
                                                            >
                                                                <Icon alt="" icon="info" size="small" />
                                                            </Tooltip>
                                                        {/* </span> */}
                                                        <span style={{float: 'right'}}>
                                                            <DropdownWithIcons modalRef={Tier1SuppliersRiskFactorsRef} kpiName={"Tier 1 Suppliers Risk Factors"} checkPDFDownloaded={checkPDFDownloaded}/>
                                                        </span>
                                                    </div>
                                                </Col>
                                                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                                    {
                                                        radarChartData && radarChartData?.length > 0 ?
                                                            <>
                                                                <RadarChartComponent data={radarChartData} riskColors={(_) => getRiskColor(_)} />
                                                                {/* <LegendList legends={[{ name: 'Suppliers Risk Factors', color: '#33ABDA' }]} /> */}</> : <NoData />
                                                    }
                                                </Col>
                                            </Row>
                                            </> : <NoData />}
                                        </Card>
                                    </div>
                                </Col><br />
                                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                    <div ref={Tier1SuppliersResiliencyRiskRef} style={{height:'100%'}}>
                                    <Card style={{ height: '100%' }} className="archlet-chart-card">
                                        {
                                            tier1SuppliersResiliencyRisk && tier1SuppliersResiliencyRisk?.length > 0 ?
                                                <>
                                                
                                                    <div className="archlet-chart-title" style={{marginBottom: '-40px'}}>
                                                        Tier 1 Supplier Resiliency Risk
                                                        
                                                    </div>
                                                    <div style={{maxWidth: "100%"}}>
                                                    <span style={{float: 'right', position: 'relative', bottom: '0.5rem'}}>
                                                            <DropdownWithIcons modalRef={Tier1SuppliersResiliencyRiskRef} kpiName={"Tier 1 Supplier Resiliency Risk"} checkPDFDownloaded={checkPDFDownloaded} isTable={true}/>
                                                        </span>
                                                    {/* <button type="primary" title='Download Data' onClick={downloadExcel} className="download-excel-resilinc">
                                                        <img src={download_logo} alt="download_logo" style={{position: 'relative', top: '2px'}}/>
                                                    </button> */}
                                                    
                                                    <AntdTable columns={columnsTable1} dataSource={tier1SuppliersResiliencyRisk} pagination={{ pageSize: 5, position: ['bottomCenter'], itemActiveBg: 'red', showSizeChanger: false, }} />
                                                    </div>
                                                </> : <NoData />
                                        }
                                    </Card>
                                    </div>
                                </Col>
                            </Row>
                            <br />
                            <Row gutter={[10, 10]} justify={"start"} style={{ width: "100%" }}>
                                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                    <div ref={mapViewRef}>
                                        <Card style={{ height: '100%' }} className="archlet-chart-card">
                                            <div style={{display:"flex", width:"100%"}}>
                                                            <div className="archlet-chart-title" >
                                                                Global Map View: PepsiCo Sites | Tier 1 Supplier Site Risks
                                                                
                                                            </div>
                                                            <span style={{display:"flex", position: 'relative', right: '0.5rem'}}>
                                                                <InfoIcon text="Use the toggle to Zoom in/out" style={{marginTop:"7px"}} direction="top-middle"/>
                                                                <Toggle
                                                                    label=""
                                                                    onUpdate={function Ma(e){
                                                                        setAllowMapZoom(e)
                                                                    }}
                                                                    size="small"
                                                                    value=""
                                                                    variant="horizontal"
                                                                />
                                                            </span>
                                                            <span style={{float: 'right'}}>
                                                                    <DropdownWithIcons modalRef={mapViewRef} kpiName={"Global Map View: PepsiCo Sites | Tier 1 Supplier Site Risks"} checkPDFDownloaded={checkPDFDownloaded}/>
                                                            </span>
                                            </div>
                                            {
                                                locations && locations?.length > 0 ?
                                                    <>
                                                        <MapWithShapes locations={locations} allowMapZoom={allowMapZoom} />
                                                        <LegendList legends={[{ name: 'Supplier Site (Risk>=6.7)', color: colors.highRisk },
                                                        { name: 'Supplier Site (3.3<Risk<6.7)', color: colors.mediumRisk },
                                                        { name: 'Supplier Site (Risk<=3.3)', color: colors.lowRisk },
                                                        { name: 'PepsiCo Site', color: colors.pepsicoSite }]} />
                                                        <br/>
                                                    </> : <NoData />
                                            }
                                        </Card>
                                    </div>
                                </Col>
                            </Row> 
                            <br />
                            <Row gutter={[10, 10]} justify={"start"} style={{ width: "100%" }}>
                                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                    <div ref={subTierFailureRef} style={{height:'100%'}}>
                                        <Card style={{ height: '100%' }}>
                                            {/* <div className="archlet-chart-title" >
                                                    Sub-tier Failure Points       
                                            </div>    */}
                                            {
                                                subTierFailurePointDetails && subTierFailurePointDetails?.length > 0 ?
                                                    <>
                                                        <ResilincFormattedTable subTierFailurePointDetails={subTierFailurePointDetails} getRiskColor={(_) => getRiskColor(_)} />
                                                        </>
                                                    : <NoData />
                                            }

                                            {/* <ResilincFormattedTable subTierFailurePointDetails={subTierFailurePointDetails} getRiskColor={(_) => getRiskColor(_)} pagination={{ pageSize: 5, position: ['bottomCenter'], itemActiveBg: 'red', showSizeChanger: false, }}/> */}
                                            {/* <Table className="commonTable" columns={mergedColumns} dataSource={subTierFailurePointFunction()} bordered pagination={false} /> */}
                                        </Card>
                                    </div>
                                </Col><br />
                                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                    <div ref={subTierSinglebarchartRef} style={{height:'100%'}}>
                                        <Card style={{ height: '100%'}} className="archlet-chart-card">
                                            {
                                                transformedSupplierMappingData && transformedSupplierMappingData?.length > 0 ?
                                                    <>
                                                        <h3 style={{ textAlign: 'left', width: '100%', color: '#3A3A3A', fontSize: '18px' }}>
                                                            # Sub-tier Suppliers mapped to Tier 1 Suppliers
                                                            {/* <span style={{float: 'right'}}> */}
                                                                {/* <DropdownWithIcons modalRef={subTierSinglebarchartRef} kpiName={"# Sub-tier Suppliers mapped to Tier 1 Suppliers"} checkPDFDownloaded={checkPDFDownloaded} isSingleBarChart={true} initialSnapshot={initialsubTierSinglebarchartRefSnapshot}/> */}
                                                                {/* <DropdownWithIcons modalRef={subTierSinglebarchartRef} kpiName={"# Sub-tier Suppliers mapped to Tier 1 Suppliers"} checkPDFDownloaded={checkPDFDownloaded} /> */}
                                                            {/* </span> */}
                                                            {/* <button onClick={()=> resilincHandleDomToImgDownloadPdf(subTierSinglebarchartRef, "# Sub-tier Suppliers mapped to Tier 1 Suppliers")}> */}
                                                            {/* <button
                                                                onClick={() => {
                                                                    setIsDownloadSingleBarChart(true);
                                                                    setCurrentStateRef(subTierSinglebarchartRef);
                                                                    setCurrentKPIName('# Sub-tier Suppliers mapped to Tier 1 Suppliers')
                                                                }}
                                                            >
                                                                PDF
                                                            </button> */}
                                                            <span style={{float: 'right'}}>
                                                                {svgSingleBarDropdownIcon(false, subTierSinglebarchartRef, '# Sub-tier Suppliers mapped to Tier 1 Suppliers', false )}
                                                            </span>
                                                        </h3>

                                                        <SingleBarChart data={isDownloadSingleBarChart ? transformedSupplierMappingData.slice(0,10) : transformedSupplierMappingData} isResilincGraph={true} />
                                                    </>
                                                    : <NoData />
                                            }

                                        </Card>
                                    </div>
                                </Col>
                                <br />

                            </Row>
                        </>
                }
                <br />
                <div className="spend-modal-manage-spend" style={{ display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center", width: '100%' }}>
                    {
                        resilincData?.owners?.length > 0 &&
                        <div style={{width: '100%'}}>Please reach out to {resilincData?.owners?.map((contact, index) => (
                            <React.Fragment key={index}>
                                <a href={`mailto:${contact.emailId}`} style={{ color: "#005cbc", textDecoration: "None" }}>{contact.emailId}</a>
                                {index < resilincData?.owners?.length - 1 && ', '}
                            </React.Fragment>
                        ))} for any query on the data displayed.</div>
                    }
                    <div style={{width: '100%'}}>Please fill in <a href={feedbackFormUrl} target="_blank" style={{ color: "#005cbc", textDecoration: "None" }}>this form</a> for any feedback related to Procurement Hub.</div>
                </div>
                {
                                showInprogressModal ? (
                                    <>
                                        <Modal
                                          
                                            closeOnOutsideClick={false}
                                            hideCloseButton
                                            //   onCloseModal={function oFe(){setInactiveModal(false)}}
                                            //   primaryButtonProps={{
                                            //     onClick: handleContinue,
                                            //     size: 'medium',
                                            //     text: 'Continue',
                                            //     variant: 'primary'
                                            //   }}
                                            //   secondaryButtonProps={{
                                            //     onClick: handleExitEditorMode,
                                            //     size: 'medium',
                                            //     text: 'Exit',
                                            //     variant: 'tertiary'
                                            //   }}
                                            showModal={true}
                                            showPrimaryButton={false}
                                              showLink={false}
                                                showSecondaryButton={false}
                                                showTertiaryButton={false}
                                                showAuxiliaryButton={false}
                                            type="S"
                                            >
                                                <div>
                                                    <div className="download-inprogress-text">Downloading In Progress... </div>
                                                </div>
                                            </Modal>
                                        
                                    </>
                                ) : <></>
                            }
                <br/>
            </div>
        </Modal>
    )
}

export default ResilincModal